/** @jsxImportSource theme-ui */
import { gql } from "@apollo/client";
import { Trans } from "@lingui/macro";
import { graphql } from "~/gql";
import ProductPrice from "../ProductPrice/ProductPrice.next";
import ShoppingCartButton from "../../Shop/ShoppingCartButton";

/** A buy button for the product in an external online shop. */
export default function ProductShopExternalButton({ product, ...rest }) {
  const onlineShop = afterQuery(product);
  if (!onlineShop) return null;
  return (
    <ShoppingCartButton
      href={onlineShop}
      target="_blank"
      rel="noopener noreferrer"
      {...rest}
    >
      {product.onlineShop ? (
        <Trans>Buy online</Trans>
      ) : (
        <Trans>Go to online shop</Trans>
      )}{" "}
      <ProductPrice
        pricing={product.pricing}
        sx={{ paddingLeft: 2, opacity: 0.8 }}
      />
    </ShoppingCartButton>
  );
}

export const fragment = graphql(`
  fragment bb_ProductShopExternalButton on Bottlebooks_Product {
    onlineShop
    producer {
      onlineShop
    }
    ... on Bottlebooks_ExtendedProduct {
      pricing {
        ...bb_ProductPrice
      }
    }
  }
`);

// ProductShopExternalButton.fragment = gql`
//   fragment ProductShopExternalButton on Product {
//     onlineShop
//     producer {
//       onlineShop
//     }
//     ... on ExtendedProduct {
//       pricing {
//         ...ProductPrice
//       }
//     }
//   }
//   ${ProductPrice.fragment}
// `;

export function afterQuery(product) {
  const onlineShop = product?.onlineShop;
  const producerOnlineShop = product?.producer?.onlineShop;
  if (!onlineShop && !producerOnlineShop) return null;
  const shop = onlineShop || producerOnlineShop;
  if (!shop) return null;
  if (shop.startsWith("http")) return shop;
  return `https://${shop}`;
}
